import React, { Component } from 'react';
import { Field, /*reduxForm*/ } from 'redux-form';
import MenuItem from 'material-ui/MenuItem'
import { chunk } from 'lodash';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import Snackbar from 'material-ui/Snackbar';

import ColorPicker from '../../colorPicker/ColorPicker';
import { renderSelectField, /*renderCheckbox, renderTextField */ } from '../../../utils/materialUiReduxForms';
import { generateCssString } from '../../../actions/clientproduct/update';
import StandingsAppDesktop from './../../samples/standingsAppDesktop';
import {flagsCdn, flagsExt, standingsAppStyleFields} from '../../../constants';
import { literals } from '../../../languages';
import { copyToClipBoard } from '../../../utils/helpers';

const SortableItem = SortableElement(({i, value, flagsCdn, flagsExt, setDefaultComp, handleRemoveCompetition}) => {

  return (
     <div className="comps-box__item-container">
       <div className={"comps-box__item " + (value.isChecked ? 'comps-box__item--default' : '') }>
        <span className="comps-box__number">{i + 1}.</span>
        <img src={`${flagsCdn}${value.flag}${flagsExt}`} alt={value.flag} />
          <span className="comps-box__comp-name">
            {value.name}
            <div className="comps-box__action-btns">
              <i onClick={() => handleRemoveCompetition(value)}className="fa fa-minus-circle comps-box__delete-btn"/>
              <span className="comps-box__default-btn" onClick={() => { setDefaultComp(value.id)} }>{value.isChecked ? '--Default--' : 'Make Default'}</span>
            </div>
          </span>
        <span className="comps-box__country">{value.countryName}</span>
      </div>
    </div>
  );
})

const SortableList = SortableContainer(({items, flagsCdn, flagsExt, setDefaultComp, handleRemoveCompetition}) => {
  return (
    <div className="sortable-wrapper">
      {items.map((value, index) => (
        <SortableItem
          key={`item-${index}`}
          value={value}
          index={index}
          i={index}
          flagsCdn={flagsCdn}
          flagsExt={flagsExt}
          setDefaultComp={setDefaultComp}
          handleRemoveCompetition={handleRemoveCompetition}
        />
      ))}
    </div>
  );
});



class StandingsAppForm extends Component {
  constructor(props){
    super(props);
    this.state = {
      comps : [],
      selectedComps : [],
      selectedCompId: '',
      expandComp: false,
      expandSelectedComp: false,
      generatedCode: '',
      showCopyMsg: false,
      indexActiveColorPicker: -1
    };
  }


  componentDidUpdate(prevProps, prevState){
    if ( prevProps.formValues.standingsCompetitions !== this.props.formValues.standingsCompetitions ) {
      let selectedComps = [];
      if (this.props.selectedCompsId && prevProps.formValues[this.props.selectedCompsId] !== this.props.formValues[this.props.selectedCompsId] && this.props.formValues[this.props.selectedCompsId] !== 'true') {
        selectedComps = JSON.parse(this.props.formValues[this.props.selectedCompsId]);
      }
      if (!selectedComps.length) {
        selectedComps = JSON.parse(this.props.formValues.defaultStandingsCompetitions);
      }
      const checkedComp = selectedComps.filter(s => s.hasOwnProperty('isChecked') && s.isChecked === true);
      let comps = JSON.parse(this.props.formValues.standingsCompetitions);
      let compsDiff = [];
      comps.forEach(c => {
        let shouldPush = true;
        selectedComps.forEach(s => {
          if (c.id === s.id) {
            shouldPush = false;
          }
        });
        if (shouldPush) {
          compsDiff.push(c);
        }
      });
      this.setState({
        'selectedComps': selectedComps,
        'comps': compsDiff,
        'selectedCompId': checkedComp[0] ? checkedComp[0].id : ''
      });
    }


    if (this.state.selectedComps === prevState.selectedComps && this.state.selectedComps.length === 0 && this.props.formValues[this.props.selectedCompsId] === prevProps.formValues[this.props.selectedCompsId]) {
      this.handleLoadDefaultComps();
    }

    if (this.props.selectedCompsId && this.props.formValues.hasOwnProperty(this.props.selectedCompsId) && prevProps.formValues[this.props.selectedCompsId] !== this.props.formValues[this.props.selectedCompsId] && this.state.selectedComps.length) {
      let selectedComps = JSON.parse(this.props.formValues[this.props.selectedCompsId]);
      const selectedCompId = selectedComps[0] ? selectedComps[0].id : '';
      const checkedComp = selectedComps.filter(s => s.hasOwnProperty('isChecked') && s.isChecked === true);

      // Init checkbox
      if (checkedComp.length === 0 && !selectedComps[0]) {
        this.setState({
          selectedComps: [],
          selectedCompId: ''
        })
      }
      else if (checkedComp.length === 0) {
        this.setState({
          selectedComps : [
            {
              ...selectedComps[0],
              isChecked: true
            },
            ...selectedComps.slice(1, selectedComps.length)
          ],
          selectedCompId
        });
      } else {
         this.setState({
          selectedComps,
          selectedCompId: checkedComp[0] ? checkedComp[0].id : ''
        });
      }
    }

    if ( this.state.selectedCompId !== '' & this.state.selectedCompId !== prevState.selectedCompId) {
      this.setState({
        'generatedCode': `<div class="standings-app-container" id="standings-app-root" data-clientId="${this.props.clientId}" data-productId="${this.props.productId}" data-sportId="${this.state.selectedCompId}"></div><script type="text/javascript">document.write('<scr' + 'ipt type="text/javascript" async src="${process.env.REACT_APP_WIDGET_ASSETS_URL}/standings-app/js/main.min.js"></scr' + 'ipt><link rel="stylesheet" type="text/css" href="${process.env.REACT_APP_WIDGET_ASSETS_CSS_URL}/${this.props.initialValues.id}.css?v=' + Date.now() + '"><link rel="stylesheet" type="text/css" href="${process.env.REACT_APP_WIDGET_ASSETS_URL}/standings-app/css/main.min.css">');</script>`
      });
    }
  }

  activeColorPicker = (index) => {
    this.setState({indexActiveColorPicker: index})
  }

  renderColorFields() {
    const chunkOfStyleFields = chunk(standingsAppStyleFields(this.props.locale).colors, 2)
    const renderColorPicker = (fields = [], index) => {
      return fields.map((f, i) => {
        return (
          <div key={`${i}${f.value}`} className="form-input-style">
            <label>{f.title} </label>
            <div
              className="colorpicker"
              onClick={() =>this.activeColorPicker(`${index}${i}`)}
            >
              <ColorPicker
                isColorPickersVisible={this.props.isColorPickersVisible && this.state.indexActiveColorPicker === `${index}${i}`}
                indexActiveColorPicker={this.state.indexActiveColorPicker}
                name={`style#${f.value}`}
                defaultValue={f.defaultValue}
                isSquareVisible
                value={this.props.formValues[f.value]}
                onChange={color => this.props.change(f.value, color)}
              />
            </div>
          </div>
        )
      })
    }

    return chunkOfStyleFields.map((sf, i) =>  <div key={`${i}ccn`} className="form-row">{renderColorPicker(sf, i)}</div>)
  }

  resetStyleFields = () => {
    standingsAppStyleFields(this.props.locale).colors.forEach(c => {
      this.props.change(c.value, c.defaultValue);
    })

    this.props.change(standingsAppStyleFields(this.props.locale).font.value, standingsAppStyleFields.font.defaultValue);
  }

  handleSortEnd = ({oldIndex, newIndex}) => {
    this.setState({
      selectedComps: arrayMove(this.state.selectedComps, oldIndex, newIndex)
    }, () => this.props.change(this.props.selectedCompsId, JSON.stringify(this.state.selectedComps)))
  }

  handleRemoveCompetition = (comp) => {
    let comps = this.state.selectedComps.filter( k => {
      return k['id'] !== comp['id'];
    });

    if (comps.length && comps.filter(s => s.hasOwnProperty('isChecked') && s.isChecked === true).length === 0) {
      // mutate the array
      comps[0] = {
        ...comps[0],
        isChecked: true
      }
    }

    this.setState({
      selectedComps: comps,
      selectedCompId: comps[0] ? comps[0].id : '',
      comps: [
        ...this.state.comps,
        comp
      ]
    }, () => this.props.change(this.props.selectedCompsId, JSON.stringify(this.state.selectedComps)));
  }

  handleCompClick = (action, comp) => {
    if (action === 'add') {
      let selected = [ ...this.state.selectedComps, comp ];
      this.setState({
        'selectedComps': selected
      });
      this.props.change(this.props.selectedCompsId, JSON.stringify(selected));

      let comps = this.state.comps.filter( k => {
        return k['id'] !== comp['id'];
      });
      this.setState({
        comps
      });
    }
  }

  setDefaultComp = (id) => {
    const { selectedComps } = this.state;
    const newSelectedComps = selectedComps.map(s => {
      if (id === s.id) {
        return {
          ...s,
          isChecked: true
        }
      }

      return {
        ...s,
        isChecked: false
      }
    });

    this.setState({
      selectedComps: newSelectedComps,
      selectedCompId: id
    }, () => this.props.change(this.props.selectedCompsId, JSON.stringify(this.state.selectedComps)))
  }

  handleLoadDefaultComps = () => {
    let defaultComps = JSON.parse(this.props.formValues.defaultStandingsCompetitions);
    let comps = JSON.parse(this.props.formValues.standingsCompetitions);
    const checkedComp = defaultComps.filter(s => s.hasOwnProperty('isChecked') && s.isChecked === true);

    let compsDiff = [];
    comps.forEach(c => {
      let shouldPush = true;
      defaultComps.forEach(s => {
        if (c.id === s.id) {
          shouldPush = false;
        }
      });
      if (shouldPush) {
        compsDiff.push(c);
      }
    });

    this.setState({
      'selectedComps': defaultComps,
      'comps': compsDiff,
      'selectedCompsId': checkedComp[0] ? checkedComp[0].id : ''
    }, () => this.props.change(this.props.selectedCompsId, JSON.stringify(this.state.selectedComps)));
  }

  handleClearAllComps = () => {
    let comps = JSON.parse(this.props.formValues.standingsCompetitions);
    this.setState({
      'selectedComps': [],
      'comps': comps
    }, () => this.props.change(this.props.selectedCompsId, JSON.stringify(this.state.selectedComps)));
  }

  renderComps = () => {
    let { comps, selectedComps } = this.state;

    return(
      <div className="competition-options">
        <div className="comps-box">
          <span onClick={()=> this.setState({expandComp: !this.state.expandComp})} className="comps-box__title">
            {literals.availableCompetitions[this.props.locale]}
            <i
              className={`fa fa-caret-down comps-box__expand-button ${this.state.expandComp ? 'comps-box__expand-button--is-open' : ''}`}
              aria-hidden="true"
            >
            </i>
          </span>
          <div className={`comps-box__inner comps-box__inner--available-comps ${this.state.expandComp ? 'comps-box__inner--expand' : ''}`}>
            {
              comps && comps.map( (c,i) =>
                <div
                  key={`availableComp${i}`}
                  onClick={()=> {this.handleCompClick('add', c)}}
                  className="comps-box__item"
                >
                  <img src={`${flagsCdn}${c.flag}${flagsExt}`} alt={c.flag} />
                  <span className="comps-box__comp-name">{c.name}</span>
                  <span className="comps-box__country">
                    {c.countryName}
                  </span>
                </div>
              )
            }
          </div>
        </div>

        <div className="comps-box">
          <div className="comps-box__actions"><div onClick={this.handleLoadDefaultComps} className="btn btn-secondary">Load Defaults</div><div onClick={this.handleClearAllComps} className="btn btn-secondary">Clear all</div></div>
          <span onClick={()=> this.setState({expandSelectedComp: !this.state.expandSelectedComp})} className="comps-box__title">
            {literals.selectedCompetitions[this.props.locale]}
            <i
              className={`fa fa-caret-down comps-box__expand-button ${this.state.expandSelectedComp ? 'comps-box__expand-button--is-open' : ''}`}
              aria-hidden="true"
            >
            </i>
          </span>
          <div className={`comps-box__inner ${this.state.expandSelectedComp ? 'comps-box__inner--expand' : ''}`}>
            {
              selectedComps &&
                <SortableList
                  distance={10}
                  items={selectedComps}
                  flagsCdn={flagsCdn}
                  flagsExt={flagsExt}
                  onSortEnd={this.handleSortEnd}
                  setDefaultComp={this.setDefaultComp}
                  handleRemoveCompetition={this.handleRemoveCompetition}
                  helperClass={"compOnSort"}
                  useWindowAsScrollContainer={false}
                />
            }
          </div>
        </div>
      </div>
    );
  }

  renderPreview () {
    return (
      <div>
        <style>
          {generateCssString(this.props.formValues)}
        </style>
        <StandingsAppDesktop />
      </div>
    );
  }

  handleCopyCode = () => {
    copyToClipBoard(this.state.generatedCode);
    this.setState({
      'showCopyMsg': true
    });
  }

  render () {
    return(
      <div>
        <div className="form-divider">{literals.competitions[this.props.locale]}</div>
        {this.renderComps()}
        <div className="form-divider">{literals.style[this.props.locale]}</div>
        {this.renderColorFields()}
        <div className="form-input-style">
          <label>{literals.fontFamily[this.props.locale]}</label>
          <Field component={renderSelectField} name="style#font-family#@standings-app-container@" type="text">
            <MenuItem value={'Open Sans'} primaryText="Default" />
            <MenuItem value={'inherit'} primaryText="Inherit" />
            <MenuItem value={'Verdana'} primaryText="Verdana" />
            <MenuItem value={'Arial'} primaryText="Arial" />
            <MenuItem value={'Sans-Serif'} primaryText="Sans-Serif" />
            <MenuItem value={'Times New Roman'} primaryText="Times New Roman" />
            <MenuItem value={'Tahoma'} primaryText="Tahoma" />
          </Field>
        </div>
        <div className="form-input-style">
          <label>{literals.lineHeight[this.props.locale]}</label>
          <Field component={renderSelectField} name="style#line-height#@generic-standings-table-body-cell@" type="text">
            <MenuItem value={'inherit'} primaryText="Default" />
            <MenuItem value={'1'} primaryText="1" />
            <MenuItem value={'1.5'} primaryText="1.5" />
            <MenuItem value={'2'} primaryText="2.5" />
            <MenuItem value={'3'} primaryText="3" />
          </Field>
        </div>
        <div className="btn btn-secondary" onClick={this.resetStyleFields}>{literals.resetToDefaults[this.props.locale]}</div>
        <div className="form-divider">{literals.previewLayout[this.props.locale]}</div>
        {this.renderPreview()}
        <div className="form-code">
          <div className="form-code__header">
            {literals.generateCodeMessage[this.props.locale]}
          </div>
          <div onClick={this.handleCopyCode} className="copy-btn">
            <span>{literals.copy[this.props.locale]}</span>
            <i className="fa fa-clipboard" aria-hidden="true"></i>
          </div>
          <Snackbar
            open={Boolean(this.state.showCopyMsg)}
            message={this.props.locale ? <div style={{textAlign:'center'}}> {literals.copySuccessMessage[this.props.locale]} <i style={{marginLeft:'15px'}}className="fa fa-check"></i></div>  : ''}
            autoHideDuration={4000}
            onRequestClose = {()=> {this.setState({'showCopyMsg': false})}}
          />
          <pre> {this.state.generatedCode} </pre>
          {
            this.state.generatedCode === ''
              ? <div className="show-code-warning">(*) {literals.standingsShowCodeMessage[this.props.locale]}</div>
              : ''
          }
        </div>
      </div>
    )
  }
}


export default StandingsAppForm;



// WEBPACK FOOTER //
// ./src/components/clientproduct/productForms/standingsApp.js